import { RefreshButton } from "@/components/admin/refresh-button";
import { UserMenu } from "@/components/admin/user-menu";
import { Separator } from "@/components/ui/separator";
import { SidebarTrigger } from "@/components/ui/sidebar";

import { NewMenu } from "./NewMenu";
import { SearchCommand } from "./SearchCommand";

/** The bar above every page (W12 U1): search, + New, refresh and the user menu. */
export function TopBar() {
  return (
    <header className="sticky top-0 z-20 flex h-14 shrink-0 items-center gap-2 border-b bg-background/95 px-4 backdrop-blur supports-[backdrop-filter]:bg-background/80">
      <SidebarTrigger className="-ml-1" />
      <Separator
        orientation="vertical"
        className="mr-1 data-[orientation=vertical]:h-5"
      />
      <div className="flex flex-1 justify-center">
        <SearchCommand />
      </div>
      <NewMenu />
      <RefreshButton />
      <UserMenu />
    </header>
  );
}
